import { DateTime } from "luxon";

/**
 * check wether the current time range coincides with today's date or if historical data should be shown
 * @param dateShown 
 * @returns 
 */
export const getIsRealTime = (dateShown: DateTime[]): boolean => {
    const now = DateTime.now();
    return dateShown[0].hasSame(now, "day") && dateShown[1].hasSame(now, "day");
};
